import React, { useEffect, useState } from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { getHistoryById } from '../../../api/historyService';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import PostsList from '../lists/PostsList';
import AttachmentsList from '../lists/AttachmentsList';
import DocumentationList from '../lists/DocumentationList';
import ProceduresList from '../lists/ProceduresList';
import LatestVitals from '../display/LatestVitals';

export default function PatientHistoryView ({ open, onClose, history = null }) {

    const handleClose = () => {
      setSelectedHistory(null);
      onClose();
    };

    const [selectedHistory, setSelectedHistory] = useState(null);

    const [updateFlag, setUpdateFlag] = useState(false);

    const fetchData = async () => {
      const res = await getHistoryById(history.id);
      setSelectedHistory(res);

      // Toggle the flag
      setUpdateFlag(prev => !prev);
    };

    const [docListRefreshKey, setDocListRefreshKey] = useState(0);
    const refreshDocumentationList = () => {
      setDocListRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        if (open && history) fetchData();
    }, [open]);

    if (!selectedHistory) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <>
                <Typography variant="body2" sx={{ mt: 0 }}>{`case no. ${selectedHistory.case_number}`}</Typography>
                <Typography variant="h6" color='primary' component="span" sx={{ mb: 0 }}>{`${selectedHistory.pet.name} (${selectedHistory.pet.owner.last_name}, ${selectedHistory.pet.owner.first_name})`}</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{formatToLocalDateTime(selectedHistory.datetime)}</Typography>
                <Typography variant="body2" sx={{ mt: 0, color: 'gray' }}>{`created by ${selectedHistory.user.name}`}</Typography>
                <LatestVitals
                  updateFlag={updateFlag}
                  pet={selectedHistory.pet}
                />
                </>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                <ProceduresList 
                  refreshDocumentationList={refreshDocumentationList}
                  fetchData={fetchData}
                  history={selectedHistory}
                  border={true}
                />
                <PostsList 
                  fetchData={fetchData}
                  history={selectedHistory}
                  posts={selectedHistory.posts} 
                  label='Primary Complaint/Notes'
                />
                {/* <DocumentationList
                  key={docListRefreshKey}
                  history={selectedHistory}
                  pet={selectedHistory.pet}
                /> */}
                {/* <AttachmentsList 
                    fetchData={fetchData}
                    history={selectedHistory}
                    attachments={selectedHistory.attachments}
                /> */}
                </Stack>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}